import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Tooltip } from '@fiverr-private/fit';
import FiverrLogo from '@fiverr-private/fit/icons/logos/fiverr_logo_nav';
import { downloadLink } from '../../../Utils';
import reportToBigQuery from '../../../Utils/bigQueryReporter';
import { sendMixPanelEvent } from '../../../Utils/mixpanel';
import { CLOSED_FILE_VIEWER, OPENED_SETTING_MODAL } from '../../../Utils/mixpanel/mixpanelEvents';
import InvitePopUpManager from '../InvitePopUpManager';
import NameModal from '../NameModal';
import PromptPendingComments from '../PendingPrompt';
import * as SettingsSelectors from '../../selectors/settings';
import * as CurrentsSelectors from '../../selectors/current';
import * as CommentsSelectors from '../../selectors/comments';
import * as CollaboratorsSelectors from '../../selectors/collaborators';
import * as FilesSelectors from '../../selectors/files';
import * as FilerrsSelectors from '../../selectors/filerrs';
import withErrorReport from '../../hocs/withErrorReport';
import * as Translations from '../../providers/i18n';
import DownloadIcon from './Download/download-icon';
import Avatars from './Avatars';
import CloseBtn from './CloseBtn';
import FileInfo from './FileInfo';

import './style.scss';

const { POSITIONS } = Tooltip;

export class Header extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            shouldShowPromptPendingComments: false
        };
    }

    onCloseClickHandler = () => {
        const {
            pendingCommentsLength,
            close
        } = this.props;

        reportToBigQuery({
            group: 'collaboration',
            type: 'clicked_file_preview_close'
        });

        sendMixPanelEvent({
            eventName: CLOSED_FILE_VIEWER,
            eventData: {
                'Close Source': 'Exit Button',
                'Has Pending Comments': !!pendingCommentsLength
            }
        });

        if (!pendingCommentsLength) {
            close();
        } else {
            this.setShouldShowPromptPendingComments(true);
        }
    };

    setShouldShowPromptPendingComments = (value) => {
        this.setState({ shouldShowPromptPendingComments: value });
    }

    onDownloadClickHandler = () => {
        const {
            currentFilerrDownloadUrl,
            currentFilerrPreviewType
        } = this.props;

        downloadLink(
            currentFilerrDownloadUrl,
            'Viewer header',
            currentFilerrPreviewType
        );
    };

    onPreferenceClickHandler = (open) => {
        const {
            currentCollaboratorId
        } = this.props;

        open();

        sendMixPanelEvent({
            eventName: OPENED_SETTING_MODAL,
            eventData: {
                'Start Collaborate Source Component': 'Preference button'
            }
        });

        reportToBigQuery({
            group: 'collaboration',
            type: 'external_collaborator_click_start_collaborating',
            collaboration: {
                collaborator: {
                    id_str: currentCollaboratorId
                }
            }
        });
    };

    render() {
        const {
            currentFilerrId,
            currentFilerrDownloadUrl,
            close,
            standalone,
            currentCollaboratorInvitePermissions,
            i18n
        } = this.props;

        const {
            shouldShowPromptPendingComments
        } = this.state;

        const canDownload = !standalone && currentFilerrDownloadUrl;

        const className = classnames('header-base', { standalone });

        return (
            <div className={className}>
                {standalone && <a href="/?utm_source=external_collaboration" target="_blank"><span className="logo"><FiverrLogo/></span>{i18n.t('attachments_preview.header.what_is_fiverr')}</a>}
                <div className="header-btns">
                    <div className="file-details-side">
                        {!standalone && <CloseBtn onClick={this.onCloseClickHandler}/>}
                        <FileInfo filerrId={currentFilerrId}/>
                        {canDownload && <DownloadIcon onClick={this.onDownloadClickHandler} className="btn-file-download"/>}
                    </div>
                    <div className="btns-side">
                        <Avatars standalone={standalone}/>
                        {currentCollaboratorInvitePermissions && <InvitePopUpManager/>}
                        {standalone && <NameModal trigger={(open) => (
                            <Tooltip content={<p className="tooltip">{i18n.t('attachments_preview.header.settings')}</p>} className="tooltip-container" delay={true} position={POSITIONS.LEFT}>
                                <button className="preference-button" onClick={() => this.onPreferenceClickHandler(open)}><span/></button>
                            </Tooltip>
                        )}/>}
                    </div>
                </div>
                <PromptPendingComments callback={close} shouldOpen={shouldShowPromptPendingComments} setShouldOpen={this.setShouldShowPromptPendingComments}/>
            </div>
        );
    }
}

Header.defaultProps = {
    standalone: false,
    attributesToShow: [],
    currentCollaboratorInvitePermissions: false
};

Header.propTypes = {
    currentFilerrId: PropTypes.string,
    currentFilerrDownloadUrl: PropTypes.string,
    currentFilerrPreviewType: PropTypes.string,
    pendingCommentsLength: PropTypes.number,
    close: PropTypes.func,
    currentCollaboratorInvitePermissions: PropTypes.bool,
    standalone: PropTypes.bool,
    currentCollaboratorId: PropTypes.string,
    i18n: PropTypes.shape({
        t: PropTypes.func
    })
};

const mapStateToProps = (state) => ({
    file: FilesSelectors.getCurrentFile(state),
    currentFilerrId: CurrentsSelectors.getCurrentFilerrId(state),
    currentFilerrDownloadUrl: FilerrsSelectors.getCurrentFilerrDownloadUrl(state),
    currentFilerrPreviewType: FilerrsSelectors.getCurrentFilerrPreviewType(state),
    pendingCommentsLength: CommentsSelectors.getPendingIdsLength(state),
    currentCollaboratorInvitePermissions: CollaboratorsSelectors.getCurrentCollaboratorInvitePermissions(state),
    standalone: SettingsSelectors.isStandaloneBehavior(state),
    currentCollaboratorId: CurrentsSelectors.getCurrentCollaboratorId(state)
});

export default compose(
    withErrorReport('Header'),
    Translations.connect,
    connect(mapStateToProps)
)(Header);
